/** @file moveKeyCommand: one clip.setKeys that moves one node's key to another frame. */
import { keyAt } from '@zilo/pose3d-commands/clip/keyAt';
import type { Command } from '@zilo/pose3d-commands/types/command';
import type { Clip } from '@zilo/pose3d-format/types/clip';

/**
 * Rewrites the source key without `node` and the target key with it (replacing a key the node had there), both in one
 * `clip.setKeys` `replace`; null when the node has no key at `from` or `from === to`.
 */
export function moveKeyCommand(clipName: string, clip: Pick<Clip, 'keys'>, node: string, from: number, to: number): Command | null {
  const source = keyAt(clip, from);
  const moved = source?.nodes[node];
  if (source === undefined || moved === undefined || from === to) return null;
  const rest = Object.fromEntries(Object.entries(source.nodes).filter(([n]) => n !== node));
  const target = keyAt(clip, to);
  return {
    name: 'clip.setKeys',
    input: {
      clip: clipName, merge: 'replace',
      keys: [{ ...source, nodes: rest }, { ...(target ?? { frame: to }), nodes: { ...(target?.nodes ?? {}), [node]: moved } }],
    },
  };
}
